module.exports = __webpack_public_path__ + "img/kf_btn.120c21e8.png";